import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/emoji/happy.png'
import _imports_1 from '@/assets/images/emoji/5565d66a50b44df9ae37a955bdfb3757.png'
import _imports_2 from '@/assets/images/emoji/cf1f643bc1244f5e8e37767bc946d607.png'
import _imports_3 from '@/assets/images/emoji/5ede936757cd4fbdb6247bad22bf454d.png'
import _imports_4 from '@/assets/images/emoji/0b356bb507d64b9489e2fbced131f795.png'


const _hoisted_1 = { class: "summary-view" }
const _hoisted_2 = { class: "p-6 bg-white shadow-sm rounded-2xl mb-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-600 mb-6" }, " Tất cả các lĩnh vực ", -1)
const _hoisted_4 = { class: "flex flex-nowrap" }
const _hoisted_5 = { class: "p-6 border rounded-l-lg border-neutral-200 w-full" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-neutral-600 mb-6" }, " 52 ", -1)
const _hoisted_7 = { class: "flex flex-nowrap items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Tổng số mục tiêu trong tuần này", -1)
const _hoisted_9 = { class: "p-6 border border-neutral-200 border-l-0 border-r-0 w-full" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-neutral-600 mb-6" }, " 10 ", -1)
const _hoisted_11 = { class: "flex flex-nowrap items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu lặp lại của tuần trước", -1)
const _hoisted_13 = { class: "p-6 border rounded-r-lg border-neutral-200 w-full" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-33 font-bold text-sienna-400 mb-6" }, "42", -1)
const _hoisted_15 = { class: "flex flex-nowrap items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-neutral-500 text-sm" }, "Mục tiêu đang tạm dừng", -1)
const _hoisted_17 = { class: "grid grid-cols-1 xl:grid-cols-2 xl:space-x-8 mb-10" }
const _hoisted_18 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden xl-down:mb-8" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ so sánh với tuần trước ", -1)
const _hoisted_20 = { class: "grid grid-cols-3 p-6 border-t border-orange-50 md-down:grid-cols-1" }
const _hoisted_21 = { class: "flex flex-col justify-center items-center w-full" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "grow-value flex flex-nowrap bg-sienna-50 rounded-lg py-1 px-2 items-center w-fit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "10",
    height: "12",
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
      fill: "#E37056"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 font-bold text-sm text-neutral-700" }, " 24% ")
], -1)
const _hoisted_23 = { class: "flex flex-col justify-center items-center" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "grow-value flex flex-nowrap bg-sienna-50 rounded-lg py-1 px-2 items-center w-fit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "10",
    height: "12",
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
      fill: "#E37056"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 font-bold text-sm text-neutral-700" }, " 24% ")
], -1)
const _hoisted_25 = { class: "flex flex-col justify-center items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "grow-value flex flex-nowrap bg-sienna-50 rounded-lg py-1 px-2 items-center w-fit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "10",
    height: "12",
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z",
      fill: "#E37056"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ml-2 font-bold text-sm text-neutral-700" }, " 24% ")
], -1)
const _hoisted_27 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ kết quả các mục tiêu của trẻ trong tuần ", -1)
const _hoisted_29 = { class: "flex flex-nowrap p-6 border-t border-orange-50" }
const _hoisted_30 = { class: "relative w-fit" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center absolute top-1/2 left-1/2 transform",
  style: {"transform":"translate(-50%, -50%)"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-4xl font-bold text-neutral-600" }, " 52 "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500" }, "Mục tiêu")
], -1)
const _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div><div class=\"flex flex-nowrap items-center mb-4\"><div class=\"text-sm font-semibold text-neutral-500 w-14 blue\"> 20 M.T </div><span class=\"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-white font-semibold shadow-input\" style=\"background:#2aa797;\"> Đạt &gt; 75% </span></div><div class=\"flex flex-nowrap items-center mb-4\"><div class=\"text-sm font-semibold text-neutral-500 w-14 font-semibold\"> 17 M.T </div><span class=\"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-white font-semibold shadow-input\" style=\"background:#65a30d;\"> Đạt 50-75% </span></div><div class=\"flex flex-nowrap items-center mb-4\"><div class=\"text-sm font-semibold text-neutral-500 w-14\"> 12 M.T </div><span class=\"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-white font-semibold shadow-input\" style=\"background:#f59e0b;\"> Đạt 25-50% </span></div><div class=\"flex flex-nowrap items-center mb-4\"><div class=\"text-sm font-semibold text-neutral-500 w-14 blue\"> 8 M.T </div><span class=\"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-white font-semibold shadow-input\" style=\"background:#f87171;\"> Đạt 25% </span></div><div class=\"flex flex-nowrap items-center\"><div class=\"text-sm font-semibold text-neutral-500 w-14 blue\"> 4 M.T </div><span class=\"inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium text-white font-semibold shadow-input\" style=\"background:#9ca3af;\"> Từ chối </span></div></div>", 1)
const _hoisted_33 = { class: "grid grid-cols-1 xl:grid-cols-2 xl:space-x-8 mb-10" }
const _hoisted_34 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden xl-down:mb-8" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ so sánh với tuần trước ", -1)
const _hoisted_36 = { class: "border-t border-orange-50 flex justify-center items-center" }
const _hoisted_37 = { class: "w-1/2" }
const _hoisted_38 = /*#__PURE__*/_createStaticVNode("<div class=\"w-1/3\"><div class=\"flex flex-nowrap items-center justify-between w-full\"><div class=\"flex flex-nowrap items-center\"><img src=\"" + _imports_0 + "\" alt=\"\" width=\"24\" height=\"24\"><div class=\"h-2.5 w-2.5 rounded-full bg-green-300 ml-2\"></div><div class=\"ml-2 text-xs text-neutral-500\"> Vui vẻ </div></div><div class=\"text-xs text-neutral-600 font-bold\"> 24% </div></div><div class=\"flex flex-nowrap items-center justify-between w-full mt-2.5\"><div class=\"flex flex-nowrap items-center\"><img src=\"" + _imports_1 + "\" alt=\"\" width=\"24\" height=\"24\"><div class=\"h-2.5 w-2.5 rounded-full bg-green-300 ml-2\"></div><div class=\"ml-2 text-xs text-neutral-500\"> Bình thường </div></div><div class=\"text-xs text-neutral-600 font-bold\"> 24% </div></div><div class=\"flex flex-nowrap items-center justify-between w-full mt-2.5\"><div class=\"flex flex-nowrap items-center\"><img src=\"" + _imports_2 + "\" alt=\"\" width=\"24\" height=\"24\"><div class=\"h-2.5 w-2.5 rounded-full bg-green-300 ml-2\"></div><div class=\"ml-2 text-xs text-neutral-500\"> Khó chịu </div></div><div class=\"text-xs text-neutral-600 font-bold\"> 24% </div></div><div class=\"flex flex-nowrap items-center justify-between w-full mt-2.5\"><div class=\"flex flex-nowrap items-center\"><img src=\"" + _imports_3 + "\" alt=\"\" width=\"24\" height=\"24\"><div class=\"h-2.5 w-2.5 rounded-full bg-green-300 ml-2\"></div><div class=\"ml-2 text-xs text-neutral-500\"> Tức giận </div></div><div class=\"text-xs text-neutral-600 font-bold\"> 24% </div></div><div class=\"flex flex-nowrap items-center justify-between w-full mt-2.5\"><div class=\"flex flex-nowrap items-center\"><img src=\"" + _imports_4 + "\" alt=\"\" width=\"24\" height=\"24\"><div class=\"h-2.5 w-2.5 rounded-full bg-green-300 ml-2\"></div><div class=\"ml-2 text-xs text-neutral-500\"> Bùng nổ </div></div><div class=\"text-xs text-neutral-600 font-bold\"> 24% </div></div></div>", 1)
const _hoisted_39 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-white shadow-sm rounded-2xl overflow-hidden\"><div class=\"font-semibold text-neutral-500 p-6\"> Chuyên cần của trẻ </div><div class=\"p-6 border-t border-orange-50\"><div><div class=\"text-neutral-500\"> Đã học / dự kiến trong tuần này </div><div class=\"text-neutral-600 text-4xl font-bold mt-5\"> 10/12 </div></div><div class=\"mt-5\"><div class=\"text-neutral-500\"> Tỷ lệ chuyên cần của trẻ tuần này so với tuần trước </div><div class=\"flex flex-nowrap items-center mt-5\"><div class=\"text-neutral-600 text-4xl font-bold mr-8\"> 87% </div><div class=\"grow-value flex flex-nowrap bg-sienna-50 rounded-lg py-1 px-2 items-center w-fit\"><svg width=\"10\" height=\"12\" viewBox=\"0 0 10 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z\" fill=\"#E37056\"></path></svg><div class=\"ml-2 font-bold text-sm text-neutral-700\"> 24% </div></div></div></div></div></div>", 1)
const _hoisted_40 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden mb-10" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500 p-6" }, " Biểu đồ mối tương quan giữa kết quả, cảm xúc và sự tham gia của trẻ trong tuần ", -1)
const _hoisted_42 = { class: "p-6 border-t border-orange-50" }
const _hoisted_43 = { class: "bg-white shadow-sm rounded-2xl overflow-hidden p-6" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full flex items-center justify-between mb-8\"><div class=\"font-semibold text-neutral-500\"> Bảng theo dõi mục tiêu của các lĩnh vực trong tuần </div><div class=\"flex items-center\"><div class=\"flex items-center flex-nowrap\"><div class=\"text-neutral-500 mr-2\"> Mục tiêu lặp lại </div><div class=\"h-5 w-5 rounded-full\" style=\"background:#eacece;\"></div></div><div class=\"flex items-center flex-nowrap ml-4\"><div class=\"text-neutral-500 mr-2\"> Mục tiêu mới </div><div class=\"h-5 w-5 rounded-full\" style=\"background:#9bbeb6;\"></div></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_12
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_DaIcon, {
              name: "das--goal",
              class: "h-4 w-4 text-yellow-600 mr-2"
            }),
            _hoisted_16
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_apexchart, {
              type: "radialBar",
              height: "240",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"]),
            _hoisted_22
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_apexchart, {
              type: "radialBar",
              height: "240",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"]),
            _hoisted_24
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_apexchart, {
              type: "radialBar",
              height: "240",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"]),
            _hoisted_26
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_apexchart, {
              height: "220",
              type: "donut",
              options: _ctx.chartOptions2,
              series: _ctx.series2
            }, null, 8, ["options", "series"]),
            _hoisted_31
          ]),
          _hoisted_32
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createVNode(_component_apexchart, {
              height: "350",
              type: "polarArea",
              options: _ctx.chartOptions3,
              series: _ctx.series3
            }, null, 8, ["options", "series"])
          ]),
          _hoisted_38
        ])
      ]),
      _hoisted_39
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_40, [
        _hoisted_41,
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_apexchart, {
            type: "line",
            options: _ctx.chartOptions4,
            series: _ctx.series4
          }, null, 8, ["options", "series"])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _createElementVNode("div", null, [
          _createVNode(_component_apexchart, {
            type: "bar",
            height: "500",
            options: _ctx.chartOptions5,
            series: _ctx.series5
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ]))
}